export const FETCH_USER_ROLES_STARTED = 'FETCH_USER_ROLES_STARTED';
export const FETCH_USER_ROLES_SUCCEEDED = 'FETCH_USER_ROLES_SUCCEEDED';
export const FETCH_USER_ROLES_FAILED = 'FETCH_USER_ROLES_FAILED';

export const VALIDATE_USER_STARTED = 'VALIDATE_USER_STARTED';
export const VALIDATE_USER_SUCCEEDED = 'VALIDATE_USER_SUCCEEDED';
export const VALIDATE_USER_FAILED = 'VALIDATE_USER_FAILED';

export const CANCEL_ROLE_MANAGEMENT = 'CANCEL_ROLE_MANAGEMENT';

export const FETCH_GUIDELINE_ROLES_STARTED = 'FETCH_GUIDELINE_ROLES_STARTED';
export const FETCH_GUIDELINE_ROLES_SUCCEEDED =
  'FETCH_GUIDELINE_ROLES_SUCCEEDED';
export const FETCH_GUIDELINE_ROLES_FAILED = 'FETCH_GUIDELINE_ROLES_FAILED';

export const ASSIGN_USER_ROLE_STARTED = 'ASSIGN_USER_ROLE_STARTED';
export const ASSIGN_USER_ROLE_SUCCEEDED = 'ASSIGN_USER_ROLE_SUCCEEDED';
export const ASSIGN_USER_ROLE_FAILED = 'ASSIGN_USER_ROLE_FAILED';

export const REMOVE_USER_ROLE_STARTED = 'REMOVE_USER_ROLE_STARTED';
export const REMOVE_USER_ROLE_SUCCEEDED = 'REMOVE_USER_ROLE_SUCCEEDED';
export const REMOVE_USER_ROLE_FAILED = 'REMOVE_USER_ROLE_FAILED';
